import { Timeline } from 'antd';
import { TaskStateColor, TaskStateColorDark } from 'core/interfaces/variables.types';
import { TaskState } from 'core/modules/tasks/task.interface';
import { getUserStore } from 'core/modules/users/user.store';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { TaskStateIcon } from '../../../types/task.types';
import { TaskActivityLabel } from './Label';
import { jsx as _jsx } from "react/jsx-runtime";
export var TaskActivityStateChanged = function TaskActivityStateChanged(_ref) {
  var activity = _ref.activity;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getUserStore = getUserStore(),
      getUserById = _getUserStore.getUserById;

  var user = getUserById(activity.authorId);
  return useMemo(function () {
    return /*#__PURE__*/_jsx(Container, {
      className: "ant-timeline-item-left ".concat(activity.data.current),
      color: TaskStateColorDark[activity.data.current],
      dot: TaskStateIcon[activity.data.current],
      label: /*#__PURE__*/_jsx(TaskActivityLabel, {
        title: t('task.progress.newState'),
        createdAt: activity.createdAt,
        user: user
      }),
      children: /*#__PURE__*/_jsx("span", {
        className: "status",
        children: t("tasks.state.".concat(activity.data.current))
      })
    });
  }, [activity, user]);
}; // Styles

var Container = styled(Timeline.Item).withConfig({
  displayName: "StateChanged__Container",
  componentId: "sc-1rc0iq9-0"
})(["min-height:75px;.status{margin:0 6px;}", ""], Object.values(TaskState).map(function (state) {
  return css(["&.", "{.ant-timeline-item-head{color:", ";}.ant-timeline-item-tail{border-color:", ";opacity:0.4;}}"], state, TaskStateColorDark[state], TaskStateColor[state]);
}));